import React from "react";
import "./Login.css";
import Logo from "../../assets/images/logo.png";

function Login() {
    return (
        <div className="login">
            <div className="login__container">
                <img src={Logo} alt="SiSC Tutoring Vara" className="logo" />
                <h1>Bine ai venit!</h1>
                <a href={process.env.REACT_APP_API_ROOT + "/api/auth/google"}>
                    Conectează-te cu Google
                </a>
            </div>
        </div>
    );
}

export default Login;
